<template>
  <add-edit-dialog>
    <crm-panel>
      <div class="page-buttons">
        <crm-button
          v-if="
            isAudit && auth.CustomerApprovePass && auth.CustomerApprovePass.toggleStatus
          "
          :text="'通过'"
          @click="pass()"
        >
        </crm-button>
        <crm-button
          v-if="
            isAudit &&
            auth.customerApproveUnPass &&
            auth.customerApproveUnPass.toggleStatus
          "
          :buttonType="'danger'"
          :text="'驳回'"
          @click="refuse()"
        >
        </crm-button>
        <crm-button :buttonType="'plain'" :text="'返回'" @click="goBack()"> </crm-button>
      </div>
      <p class="check-title">查看客户</p>
      <div class="form-wrap">
        <div class="title">基本信息</div>
        <!-- 企业信息模板 -->
        <div
          class="info form-info"
          v-if="
            customDetailInfo.commonCustomer &&
            customDetailInfo.commonCustomer.categoryUid !==
              'ed67aad9552b4f1b8520785b9cb4bfd1'
          "
        >
          <el-row>
            <el-col :span="4">
              <div class="info-title">客户类型：</div>
            </el-col>
            <el-col :span="20">
              <div
                class="info-detail"
                v-text="
                  customDetailInfo.commonCustomer &&
                  customDetailInfo.commonCustomer.categoryName
                "
              ></div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4">
              <div class="info-title">客户等级：</div>
            </el-col>
            <el-col :span="20">
              <div
                class="info-detail"
                v-text="
                  customDetailInfo.commonCustomer &&
                  customDetailInfo.commonCustomer.customerLevelName
                "
              ></div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4">
              <div class="info-title">客户名称：</div>
            </el-col>
            <el-col :span="20">
              <div class="info-detail">
                {{
                  customDetailInfo.commonCustomer && customDetailInfo.commonCustomer.name
                }}
                {{
                  customDetailInfo.commonCustomer &&
                  customDetailInfo.commonCustomer.depaName
                }}
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4">
              <div class="info-title">统一社会信用代码：</div>
            </el-col>
            <el-col :span="20">
              <div class="info-detail" v-text="customDetailInfo.creditCode"></div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-col :span="8">
                <div class="info-title">注册资金（万元）：</div>
              </el-col>
              <el-col :span="16">
                <div class="info-detail">
                  {{
                    customDetailInfo.commonCustomer &&
                    customDetailInfo.commonCustomer.capital
                  }}
                </div>
              </el-col>
            </el-col>
            <el-col :span="12">
              <el-col :span="8">
                <div class="info-title">规模（人）：</div>
              </el-col>
              <el-col :span="16">
                <div class="info-detail">
                  {{
                    customDetailInfo.commonCustomer &&
                    customDetailInfo.commonCustomer.scale
                  }}
                </div>
              </el-col>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-col :span="8">
                <div class="info-title">地区：</div>
              </el-col>
              <el-col :span="16">
                <div class="info-detail">
                  {{
                    customDetailInfo.commonCustomer &&
                    customDetailInfo.commonCustomer.province
                  }}
                  {{
                    customDetailInfo.commonCustomer &&
                    customDetailInfo.commonCustomer.city
                  }}
                  {{
                    customDetailInfo.commonCustomer &&
                    customDetailInfo.commonCustomer.district
                  }}
                </div>
              </el-col>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4">
              <div class="info-title">详细地址：</div>
            </el-col>
            <el-col :span="20">
              <div class="info-detail" v-text="customDetailInfo.streetAddress"></div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4">
              <div class="info-title">业务员：</div>
            </el-col>
            <el-col :span="20">
              <div class="info-detail">
                {{
                  customDetailInfo.commonCustomer &&
                  customDetailInfo.commonCustomer.salesmanName
                }}
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4">
              <div class="info-title">业务员所属团队：</div>
            </el-col>
            <el-col :span="20">
              <div class="info-detail">
                {{
                  customDetailInfo.commonCustomer &&
                  customDetailInfo.commonCustomer.teamName
                }}
              </div>
            </el-col>
          </el-row>
        </div>
        <!-- 医院信息模板 -->
        <div
          class="info form-info"
          v-if="
            customDetailInfo.commonCustomer &&
            customDetailInfo.commonCustomer.categoryUid ===
              'ed67aad9552b4f1b8520785b9cb4bfd1'
          "
        >
          <el-row>
            <el-col :span="4">
              <div class="info-title">客户类型：</div>
            </el-col>
            <el-col :span="20">
              <div
                class="info-detail"
                v-text="
                  customDetailInfo.commonCustomer &&
                  customDetailInfo.commonCustomer.categoryName
                "
              ></div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4">
              <div class="info-title">客户等级：</div>
            </el-col>
            <el-col :span="20">
              <div
                class="info-detail"
                v-text="
                  customDetailInfo.commonCustomer &&
                  customDetailInfo.commonCustomer.customerLevelName
                "
              ></div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-col :span="8">
                <div class="info-title">客户名称：</div>
              </el-col>
              <el-col :span="16">
                <div class="info-detail">
                  {{
                    customDetailInfo.commonCustomer &&
                    customDetailInfo.commonCustomer.name
                  }}
                  {{
                    customDetailInfo.commonCustomer &&
                    customDetailInfo.commonCustomer.depaName
                  }}
                </div>
              </el-col>
            </el-col>
            <el-col :span="12">
              <el-col :span="8">
                <div class="info-title">跟进状态：</div>
              </el-col>
              <el-col :span="16">
                <div class="info-detail">
                  {{ customDetailInfo.followUpStateName }}
                </div>
              </el-col>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-col :span="8">
                <div class="info-title">医院等级：</div>
              </el-col>
              <el-col :span="16">
                <div class="info-detail">
                  {{ customDetailInfo.hospitalLevelName }}
                </div>
              </el-col>
            </el-col>
            <el-col :span="12">
              <el-col :span="8">
                <div class="info-title">病床数：</div>
              </el-col>
              <el-col :span="16">
                <div class="info-detail">
                  {{ customDetailInfo.sickbedNumber }}
                </div>
              </el-col>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-col :span="8">
                <div class="info-title">覆盖人口(万)：</div>
              </el-col>
              <el-col :span="16">
                <div class="info-detail">
                  {{ customDetailInfo.coverPopulation }}
                </div>
              </el-col>
            </el-col>
            <el-col :span="12">
              <el-col :span="8">
                <div class="info-title">当地医院排名：</div>
              </el-col>
              <el-col :span="16">
                <div class="info-detail">
                  {{ customDetailInfo.hospitalRhanking }}
                </div>
              </el-col>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-col :span="8">
                <div class="info-title">年收入(万元)：</div>
              </el-col>
              <el-col :span="16">
                <div class="info-detail">
                  {{ customDetailInfo.annualIncome }}
                </div>
              </el-col>
            </el-col>
            <el-col :span="12">
              <el-col :span="8">
                <div class="info-title">职工人数：</div>
              </el-col>
              <el-col :span="16">
                <div class="info-detail">
                  {{ customDetailInfo.employeeNumber }}
                </div>
              </el-col>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-col :span="8">
                <div class="info-title">年门诊人次(万)：</div>
              </el-col>
              <el-col :span="16">
                <div class="info-detail">
                  {{ customDetailInfo.outpatientVisits }}
                </div>
              </el-col>
            </el-col>
            <el-col :span="12">
              <el-col :span="8">
                <div class="info-title">合作科室：</div>
              </el-col>
              <el-col :span="16">
                <div class="info-detail">
                  {{
                    customDetailInfo.customerDetail
                      .map((item) => item.dictName)
                      .join("、")
                  }}
                </div>
              </el-col>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-col :span="8">
                <div class="info-title">年住院人次(万)：</div>
              </el-col>
              <el-col :span="16">
                <div class="info-detail">
                  {{ customDetailInfo.hospitalizationVisits }}
                </div>
              </el-col>
            </el-col>
            <el-col :span="12">
              <el-col :span="8">
                <div class="info-title">负债率：</div>
              </el-col>
              <el-col :span="16">
                <div class="info-detail">
                  {{
                    customDetailInfo.liabilities ? customDetailInfo.liabilities + "%" : ""
                  }}
                </div>
              </el-col>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-col :span="8">
                <div class="info-title">医疗设备：</div>
              </el-col>
              <el-col :span="16">
                <div class="info-detail">
                  {{ customDetailInfo.medicalEquipment === 1 ? "有" : "无" }}
                </div>
              </el-col>
            </el-col>
            <el-col :span="12" v-if="customDetailInfo.medicalEquipment === 1">
              <el-col :span="8">
                <div class="info-title">设备总金额(万元)：</div>
              </el-col>
              <el-col :span="16">
                <div class="info-detail">
                  {{ customDetailInfo.deviceAmount }}
                </div>
              </el-col>
            </el-col>
          </el-row>
          <el-row v-if="customDetailInfo.medicalEquipment === 1">
            <el-col :span="4">
              <div class="info-title">设备名称：</div>
            </el-col>
            <el-col :span="20">
              <div class="info-detail">
                {{ customDetailInfo.deviceName }}
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-col :span="8">
                <div class="info-title">耗材：</div>
              </el-col>
              <el-col :span="16">
                <div class="info-detail">
                  {{ customDetailInfo.consumables === 1 ? "有" : "无" }}
                </div>
              </el-col>
            </el-col>
            <el-col :span="12" v-if="customDetailInfo.consumables === 1">
              <el-col :span="8">
                <div class="info-title">耗材流水(万元/年)：</div>
              </el-col>
              <el-col :span="16">
                <div class="info-detail">
                  {{ customDetailInfo.consumablesRunningWater }}
                </div>
              </el-col>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4">
              <div class="info-title">备注：</div>
            </el-col>
            <el-col :span="20">
              <div class="info-detail">
                {{ customDetailInfo.customerRemarks }}
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4">
              <div class="info-title">地区：</div>
            </el-col>
            <el-col :span="20">
              <div class="info-detail">
                {{
                  customDetailInfo.commonCustomer &&
                  customDetailInfo.commonCustomer.province
                }}
                {{
                  customDetailInfo.commonCustomer && customDetailInfo.commonCustomer.city
                }}
                {{
                  customDetailInfo.commonCustomer &&
                  customDetailInfo.commonCustomer.district
                }}
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4">
              <div class="info-title">详细地址：</div>
            </el-col>
            <el-col :span="20">
              <div class="info-detail" v-text="customDetailInfo.streetAddress"></div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4">
              <div class="info-title">业务员：</div>
            </el-col>
            <el-col :span="20">
              <div class="info-detail">
                {{
                  customDetailInfo.commonCustomer &&
                  customDetailInfo.commonCustomer.salesmanName
                }}
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4">
              <div class="info-title">业务员所属团队：</div>
            </el-col>
            <el-col :span="20">
              <div
                class="info-detail"
                v-text="
                  customDetailInfo.commonCustomer &&
                  customDetailInfo.commonCustomer.teamName
                "
              ></div>
            </el-col>
          </el-row>
        </div>
        <!-- 联系人列表 -->
        <div class="title">联系人</div>
        <div class="form-info">
          <el-table :data="detailContracts.results" border style="width: 100%">
            <el-table-column prop="name" align="center" label="姓名"> </el-table-column>
            <el-table-column prop="mobile" align="center" label="联系方式">
            </el-table-column>
            <el-table-column prop="typeName" align="center" label="类型">
            </el-table-column>
            <el-table-column prop="duty" align="center" label="职务"> </el-table-column>
            <el-table-column prop="contactDepa" align="center" label="部门">
            </el-table-column>
            <el-table-column prop="contactEmail" align="center" label="邮箱">
            </el-table-column>
          </el-table>
          <el-pagination
            class="linkman-pagination"
            @current-change="handleCurrentChange"
            :current-page.sync="contacts.pageNumber"
            :page-size.sync="contacts.pageSize"
            layout="total, prev, pager, next"
            :total="detailContracts.totalCount"
          >
          </el-pagination>
        </div>
        <!-- 审核备注 -->
        <div class="title" v-if="!isFromCustom">审核备注</div>
        <div class="form-info" v-if="!isFromCustom">
          <el-input
            class="audit-remark"
            v-if="isAudit"
            type="textarea"
            :rows="4"
            v-model="remark"
            placeholder="请输入审核备注"
          ></el-input>
          <ul class="remark-info" v-if="isAudit">
            <li>说明：</li>
            <li>1.通过操作时，审核备注非必填。</li>
            <li>2.驳回操作时，审核备注必填。</li>
          </ul>
          <span v-else>{{ remark }}</span>
        </div>
      </div>
    </crm-panel>
  </add-edit-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import AddEditDialog from "@/components/base/addEditDialog";
import CrmPanel from "@/components/base/crmPanel";
import CrmButton from "@/components/base/crmButton";

export default {
  components: {
    CrmButton,
    CrmPanel,
    AddEditDialog,
  },
  props: {
    detail: Object,
    isFromCustom: Boolean,
  },
  data() {
    return {
      auditionModule: null,
      remark: "",
      contacts: {
        pageNumber: 1,
        pageSize: 10,
      },
      isContactsLoading: false,
      customDetailInfo: {},
      detailContracts: {},
    };
  },
  computed: {
    ...mapGetters({
      auth: "authority/auth",
      clientAuditDetail: "audit/clientAuditDetail",
      auditContacts: "audit/auditContacts",
      customDetail: "customer/customDetail",
      customContacts: "customer/customContacts",
    }),
    isAudit() {
      return this.detail.isAudit;
    },
  },
  created() {
    this.getDetailData();
    this.handleGetCustomContacts();
  },
  methods: {
    ...mapActions({
      getClientAuditDetail: "audit/getClientAuditDetail",
      passClientAudit: "audit/passClientAudit",
      refuseClientAudit: "audit/refuseClientAudit",
      getAuditContactsList: "audit/getAuditContactsList",
      getCustomDetail: "customer/getCustomDetail",
      getCustomContacts: "customer/getCustomContacts",
    }),
    getDetailData() {
      if (this.isFromCustom) {
        this.getCustomDetail({
          uid: this.detail.uid,
          type: this.detail.type,
        }).then(() => {
          this.remark = this.customDetail.commonCustomer.remark;
          this.customDetailInfo = this.customDetail;
        });
      } else {
        this.getClientAuditDetail({
          uid: this.detail.uid,
          type: this.detail.type,
        }).then(() => {
          this.remark = this.clientAuditDetail.commonCustomer.remark;
          this.customDetailInfo = this.clientAuditDetail;
        });
      }
    },
    handleGetCustomContacts() {
      this.isContactsLoading = true;
      if (this.isFromCustom) {
        this.getCustomContacts({
          customerUid: this.detail.uid,
          pageNumber: this.contacts.pageNumber,
          pageSize: this.contacts.pageSize,
          sourcePart: "customer",
        })
          .then(() => {
            this.detailContracts = this.customContacts;
          })
          .finally(() => {
            this.isContactsLoading = false;
          });
      } else {
        this.getAuditContactsList({
          customerUid: this.detail.uid,
          pageNumber: this.contacts.pageNumber,
          pageSize: this.contacts.pageSize,
        })
          .then(() => {
            this.detailContracts = this.auditContacts;
          })
          .finally(() => {
            this.isContactsLoading = false;
          });
      }
    },
    handleCurrentChange() {
      this.handleGetCustomContacts();
    },
    pass() {
      this.passClientAudit({
        uid: this.detail.uid,
        remark: this.remark,
      }).then(() => {
        this.$message({
          message: "审核通过",
          type: "success",
        });
        this.goBack();
      });
    },
    refuse() {
      if (!this.remark) {
        this.$message.error("驳回操作时，审核备注必填！");
        return;
      }
      this.refuseClientAudit({
        uid: this.detail.uid,
        remark: this.remark,
      }).then(() => {
        this.$message({
          message: "审核驳回",
          type: "success",
        });
        this.goBack();
      });
    },
    goBack() {
      this.$emit("close");
    },
  },
};
</script>
<style lang="less" scoped>
@import "~@/styles/var.less";
@import "~@/styles/const.less";

.crm-panel {
  padding: 70px 0 0 70px;
}
.page-buttons {
  z-index: 1;
  top: 10px;
}
.form-wrap {
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: auto;
  padding-bottom: 70px;
  padding-right: 70px;
  .form-info {
    padding: 20px 170px;
    .info-title {
      text-align: right;
      line-height: 40px;
      color: @color--info;
      font-size: @font-size;
      font-weight: 500;
    }
    .info-detail {
      color: @color--primary;
      line-height: 40px;
    }
  }
  .linkman-pagination {
    text-align: right;
  }
}
.remark-info {
  margin: 5px 0;
  margin-left: -40px;
  font-size: 12px;
  color: #717094;
  li {
    margin: 5px 0;
  }
}
</style>
